import AssetImage from '@/presentation/components/elements/AssetImage';
import { Icons } from '@/presentation/components/elements/Icon';
import Icon from '@/presentation/components/elements/Icon/Icon';
import NftQuantity from '@/presentation/components/modules/NftQuantity';

export interface NftProps {
  selected: boolean;
  assetAddress: `0x${string}`;
  className?: string;
  tokenId: `${number}`;
  maxQuantity: number;
  quantity: number;
  imageUrl: string;
  name: string;
  is1155: boolean;
  onClick: () => void;
  onChangeQuantity: (quantity: number) => void;
}

export const Nft = ({
  selected,
  className,
  assetAddress,
  tokenId,
  imageUrl,
  name,
  maxQuantity,
  quantity,
  is1155,
  onClick,
  onChangeQuantity,
}: NftProps) => {
  return (
    <figure
      className={`relative grid ${
        className ?? ''
      } rounded-md overflow-hidden m-1 ring-2 ${
        selected ? 'ring-pink-500' : 'ring-transparent hover:ring-gray-300/50'
      }`}
    >
      <AssetImage
        assetAddress={assetAddress}
        tokenId={tokenId}
        imageUrl={imageUrl}
        name={name}
        onClick={onClick}
      />
      {selected ? (
        <span className="bg-pink-500 absolute top-1.5 right-1.5 p-0.5 rounded-full border border-gray-50">
          <Icon name={Icons.CHECK} className="text-white" size={12} />
        </span>
      ) : null}
      {is1155 && (
        <NftQuantity
          selected={selected}
          maxQuantity={maxQuantity}
          value={quantity}
          onChange={onChangeQuantity}
        />
      )}
      <span className="bg-gray-50 p-0.5 rounded-b-md border-l border-r border-b border-gray-300 text-xs truncate">
        {`#${tokenId}`}
      </span>
    </figure>
  );
};

export default Nft;
